"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activateTrial = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _Trials = require("self-service-api/constants/Trials");

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _startTrial = require("ui-addon-upgrades/_core/common/api/startTrial");

var _wrapWithErrorMonitoring = _interopRequireDefault(require("ui-addon-upgrades/_core/common/reliability/wrapWithErrorMonitoring"));

var activateTrial = (0, _wrapWithErrorMonitoring.default)('activateTrial', function (upgradeData) {
  var trialId = upgradeData.trialId,
      upgradeProduct = upgradeData.upgradeProduct,
      source = upgradeData.source; // Default to 14-day trials if no default specified

  var defaultDurationInDays = _Trials.upgradeProductToDefaultDuration[upgradeProduct] || 14;

  var endDate = _I18n.default.moment().add(defaultDurationInDays, 'days').valueOf();

  return (0, _startTrial.startTrial)(trialId, endDate, source).then(function () {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('trialActivationInteraction', (0, _extends2.default)({
      action: 'activation succeeded'
    }, upgradeData)); //MON203 - setting localstorage flag on marketing pro trials use in trial banner

    if (trialId === 4) {
      localStorage.setItem('growth-mon203-shepherd', true);
    }
  }).catch(function (e) {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('trialActivationInteraction', (0, _extends2.default)({
      action: 'activation failed'
    }, upgradeData));

    _devLogger.default.warn({
      message: e,
      key: 'TrialActivationButton'
    });

    if (window.Raven) {
      window.Raven.captureMessage('Trial activation failed', {
        extra: {
          error: e
        }
      });
    }

    throw e;
  });
});
exports.activateTrial = activateTrial;